module.exports = __webpack_public_path__ + "83c82c786676ed57a0b74e7b79fa5428.svg";